import { keyToNavData } from 'developer-docs-shared-components/config/navData/keys';
import { generateUrlWithVersionFromBaseUrl } from 'developer-docs-shared-components/config/versionInfo';
import RelatedDocs from 'developer-docs-shared-components/components/RelatedDocs';
import { useLocation } from 'react-router-dom';
import { API_GUIDES_PREFIX, REFERENCE_PREFIX } from '../utils/urls';

/**
 * The 'Related Apis' section shown at the top of a Guide Page.
 */
import { jsx as _jsx } from "react/jsx-runtime";
const RelatedApiLink = () => {
  const location = useLocation();
  const currentGuideKey = location.pathname.replace(`/${API_GUIDES_PREFIX}`, '');
  const pageData = keyToNavData['/reference/api'][currentGuideKey.replace('.mdx', '')];
  if (!pageData) return null;
  const apiGuideRoute = `/${REFERENCE_PREFIX}${generateUrlWithVersionFromBaseUrl(currentGuideKey)}`;
  const title = pageData.label();
  return /*#__PURE__*/_jsx(RelatedDocs, {
    href: apiGuideRoute,
    title: title,
    relatedDocType: "api"
  });
};
export default RelatedApiLink;